module.exports = __webpack_public_path__ + "img/carousel-img-3@3x.28d688c3.jpg";